import { render, staticRenderFns } from "./shipment-report-private.vue?vue&type=template&id=0237f46b&scoped=true&"
import script from "./shipment-report-private.vue?vue&type=script&lang=js&"
export * from "./shipment-report-private.vue?vue&type=script&lang=js&"
import style0 from "./shipment-report-private.vue?vue&type=style&index=0&id=0237f46b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0237f46b",
  null
  
)

export default component.exports